<template lang="pug">
    model-data-table(
        loading-text="Cargando promociones..."
        no-data-text="Sin promociones."
        no-search
        ref="table"
        remind-key='wh-promo-list'
        v-bind="tableProps"
        @detail="submitShow"
        @remove="remove"
        :no-detail="!$can('VIEW_DETAIL_PRODUCT_PROMO')"
        :no-remove="!$can('DELETE_PRODUCT_ITEM')"
        )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import PromoService from '@/services/api/promo'
//
import ProviderService from '@/services/api/provider'
import WarehouseService from '@/services/api/warehouse'
import FamilyService from '@/services/api/family/FamilyServices'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import TagService from '@/services/api/tag/TagServices'
import SaleUtils from '@/services/SaleUtils'
//
import MdlProduct from '../../models/Warehouse/WhProduct'
import PromosFilters from './partials/filters/list'
import PromosHeaders from './partials/headers/list'
//
export default {
    name: 'promos-list',
    components: {
        'model-data-table': ModelDataTable,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        /*
         */
        ...mapState('AuthModule', ['user']),

        /**
         *
         */
        currentBranchOfficeId() {
            return 2
            //return this.currentUser ? this.currentUser.hr_employee.g_branch_office : 1
        },

        /**
         *
         */
        currentUser() {
            console.log(this.$store.state.AuthModule.user)
            return this.$store.state.AuthModule.user
        },
        tableProps() {
            return {
                filters: this.filters,
                headers: this.headers,
                paramFilter: {
                    type: 'promo',
                },
                service: MdlProduct,
                mapper: row => {
                    row.branchOfficeId = this.user.hr_employee.g_branch_office_id
                    return row
                },
                // .where('type', 'item')
                // .includes('sl_wholesale_discounts')
                // .appends('sale_prices', 'stocks', 'branch_offices'),
            }
        },
    },
    data() {
        return {
            filters: PromosFilters,
            headers: PromosHeaders,
            // service: PromoService,
            selectedItemId: null,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        computedCostPrice(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.cost_price : 0
        },

        /**
         *
         */
        computedCriticalStock(item) {
            //
            const branch_office = item.branch_offices.find(
                this.findBranchOffice
            )
            //
            return branch_office ? branch_office.critical_stock : 0
        },

        /**
         *
         */
        computedGainMargin(item) {
            //
            const branch_office = item.branch_offices.find(
                    this.findBranchOffice
                ),
                sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return branch_office && sale_price
                ? SaleUtils.getMargin(
                      sale_price.sale_price,
                      branch_office.cost_price
                  ) + ' %'
                : 0
        },

        /**
         *
         */
        computedSalePrice(item) {
            //
            const sale_price = item.sale_prices.find(this.findSalePrice)
            //
            return sale_price ? sale_price.sale_price : 0
        },

        /**
         *
         */
        findBranchOffice(branch_office) {
            return (
                this.currentBranchOfficeId === branch_office.g_branch_office_id
            )
        },

        /**
         *
         */
        findSalePrice(sale_price) {
            return this.currentBranchOfficeId === sale_price.branch_office_id
        },

        /**
         *
         */
        async refresh() {
            this.$refs.table.checkAndFetch()
        },

        /**
         *
         */
        submitShow: function(event) {
            // $router.push('/promos/'+$event)
            this.$router.push(`/promos/${event.item.id}`)
        },
        remove: async function(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar promoción')
            this.showSnackbar('warning', '¿Deseas eliminar la promoción?')
            //
            this.selectedItemId = event.item.id
        },

        /**
         *
         */
        async removeSelectedItem() {
            //
            const response = await PromoService.remove(this.selectedItemId)
            //
            switch (response.status) {
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Promoción Eliminada.',
                        this.refresh
                    )
                    break
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar('warning', 'Error.', response.error)
                    break
            }
        },
        /**
         *
         */
        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },
    },
    beforeMount() {
        this.setTitleTopBar('Promociones')
        this.$setItemsTopBar([
            {
                text: 'crear promoción',
                icon: 'add',
                can: 'CREATE_PRODUCT_PROMO',
                action: () => this.$router.push('/promos/create'),
            },
        ])
    },
    watch: {
        /**
         *
         */
        async responseConfirm(message) {
            switch (message) {
                case 'eliminar promoción':
                    return this.removeSelectedItem()
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT_PROMO')) ctx.$router.push('/')
        })
    },
}
</script>
